import fetchWithCache from './fetchWithCache';

const fetchStandardFeatures = ({ servicesPath, modelPath, styleId }) => {
  const url = `${servicesPath}/standard-features/${modelPath}/${styleId}`;
  return fetchWithCache(url).then(data => data.features);
};

export default fetchStandardFeatures;
